import './podcast.scss';
import { loadScript } from '../../utilities/js/helper';

class Podcast {
    constructor ($element, options) {
        this.$podcastModul = $element;
        this.$podcasts = this.$podcastModul.querySelectorAll('[data-podcast-id]');
        this.embedController = [];
        this.activePodCast = null;
    }

    initialize () {
        this.loadAPI();
    }

    loadAPI () {
        loadScript('https://open.spotify.com/embed/iframe-api/v1').then((data) => {
            window.onSpotifyIframeApiReady = (IFrameAPI) => {
                this.iFrameApi = IFrameAPI;
                this.initPodcasts();
            };
        });
    }

    initPodcasts () {
        this.$podcasts.forEach((podcast, index) => {
            const url = 'spotify:episode:' + this.createEpisodeId(podcast.dataset.podcastUrl);

            const options = {
                uri: url
            };

            this.iFrameApi.createController(podcast, options, (EmbedController) => {
                this.embedController[index] = EmbedController;

                this.embedController[index].addListener('playback_update', e => {
                    if (!e.isPaused) {
                        if (this.activePodCast !== this.embedController[index]) {
                            if (this.activePodCast !== null) {
                                this.activePodCast.pause();
                            }
                            this.activePodCast = this.embedController[index];
                        }
                    }
                });
            });
        });
    }

    createEpisodeId (uri) {
        return uri.substring((uri.lastIndexOf('/') + 1), uri.indexOf('?'));
    }
}

export { Podcast };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$podcast = $context.querySelectorAll('[data-podcast="root"]');

        for (let i = 0; i < $$podcast.length; i++) {
            const podcast = new Podcast($$podcast[i]);
            podcast.initialize();
        }
    }
});
